/**
 * `/$org/workflows/$workflowId`: one workflow's chart, for editing, or a run
 * of it with `?run=<id>` (and `&step=<id>` to open one of its steps, as the
 * Inbox does for an approval); `?chat=<threadId>` opens Ask eve on that
 * thread. The search type is exported: the generated route tree names it.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

import { HomePageRoute } from "../components/home/HomePageRoute";
import { WorkflowPage } from "../components/workflows/WorkflowPage";
import { parseWorkflowSearch, type WorkflowSearch, withRun } from "../components/workflows/workflowSearch";

export type { WorkflowSearch };

function WorkflowRouteView() {
  const { workflowId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <HomePageRoute>
      <WorkflowPage
        workflowId={workflowId}
        runId={search.run ?? null}
        stepId={search.step ?? null}
        chatId={search.chat ?? null}
        onSelectRun={(next) => void navigate({ search: (current) => withRun(current, next), replace: false, resetScroll: false })}
      />
    </HomePageRoute>
  );
}

export const Route = createFileRoute("/$org/workflows/$workflowId")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  validateSearch: (search: Record<string, unknown>): WorkflowSearch => parseWorkflowSearch(search),
  component: WorkflowRouteView,
});
